import type { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@/meta/common";

const productActivityRouter: RouteRecordRaw[] = [
    {
        path: "/productActivity",
        name: "ProductActivity",
        component: () => import("@/layouts/index.vue"),
        meta: {
            title: "商品活动",
            authOptions: [
                {
                    label: "查看",
                    value: "ROLE_ACTI_R"
                },
                {
                    label: "管理",
                    value: "ROLE_ACTI_W"
                },
                {
                    label: "查看",
                    value: "ROLE_ACTIORDER_R"
                },
                {
                    label: "管理",
                    value: "ROLE_ACTIORDER_W"
                }
            ]
        },
        children: [
            {
                path: "activityList",
                name: "ActivityList",
                component: () => import("@/views/pages/tradeManage/activityManagement/activityList/index.vue"),
                meta: {
                    title: "活动列表",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "ActivityList",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ACTI_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ACTI_W"
                        }
                    ]
                }
            },
            {
                path: "activity/detail",
                name: "ActivityDetail",
                component: () => import("@/views/pages/tradeManage/activityManagement/activityList/detail.vue"),
                meta: {
                    title: "活动详情",
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "ActivityList",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ACTI_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ACTI_W"
                        }
                    ]
                }
            },
            {
                path: "/activityManagement/activeGoodsDetail",
                name: "ActiveGoodsDetail",
                component: () => import("@/views/pages/tradeManage/activityManagement/activeGoodsDetail/index.vue"),
                meta: {
                    title: "活动商品详情",
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "ActivityList",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ACTI_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ACTI_W"
                        }
                    ]
                }
            },
            {
                path: "activity/add",
                name: "ActivityAdd",
                component: () => import("@/views/pages/tradeManage/activityManagement/activityList/form.vue"),
                meta: {
                    title: "新增活动",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "ActivityList",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ACTI_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ACTI_W"
                        }
                    ]
                }
            },
            {
                path: "activity/edit",
                name: "ActivityEdit",
                component: () => import("@/views/pages/tradeManage/activityManagement/activityList/form.vue"),
                meta: {
                    title: "编辑活动",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "ActivityList",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ACTI_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ACTI_W"
                        }
                    ]
                }
            },
            {
                path: "activityOrder",
                name: "ActivityOrder",
                component: () => import("@/views/pages/tradeManage/activityManagement/activityOrder/index.vue"),
                meta: {
                    title: "活动订单",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "ActivityOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ACTIORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ACTIORDER_W"
                        }
                    ]
                }
            }
        ]
    }
];

export default productActivityRouter;
